import { inspect as w } from "effector/inspect";
function P({
  scope: e,
  name: t,
  trace: n,
  devToolsConfig: u,
  batch: o = !0,
  stateTab: r = !1
} = {}) {
  var $;
  const l = X();
  if (!l)
    return x();
  const d = W(r), {
    state: i
  } = d, a = l.connect({
    name: C(t),
    maxAge: typeof o == "object" ? o.size : void 0,
    latency: typeof o == "object" ? o.latency : void 0,
    ...u
  });
  a.init(i);
  const E = U(d), I = q(a, i, o), S = w({
    scope: e,
    trace: n,
    fn: (s) => {
      const c = E(s);
      c && (n && (c.trace = B(s.trace)), s.loc && (c.loc = s.loc), c.id = s.id, I(c));
    }
  }), v = ($ = a == null ? void 0 : a.subscribe) == null ? void 0 : $.call(a, (s) => {
    var c;
    if (((c = s == null ? void 0 : s.payload) == null ? void 0 : c.type) === "COMMIT") {
      a.init(i);
      return;
    }
  });
  return () => {
    S(), v == null || v();
  };
}
function x() {
  return console.error("Redux DevTools extension is not connected :("), () => {
  };
}
function C(e) {
  return e ? `☄️ ${e}` : typeof document == "object" ? `☄️ ${document.title}` : "☄️ no title instance";
}
function U(e) {
  return (t) => {
    var n;
    if (t.type === "error")
      return {
        type: `⛔️ [error] [${t.kind}] ${f(t)}`,
        explanation: "Error in pure function, branch computation stopped",
        name: f(t),
        value: t.value,
        error: (n = t == null ? void 0 : t.error) != null && n.message ? t.error.message : t.error
      };
    if (k(t))
      return R(t), {
        type: `☄️ [effect] ${t.name || "unknown"}`,
        params: t.value
      };
    if (_(t) && e.saveStoreUpdate(t), h(t)) {
      const u = z(t);
      return t.value.status === "done" ? {
        type: `✅ [effect] ${u}.done`,
        params: t.value.params,
        result: t.value.result
      } : t.value.status === "fail" ? {
        type: `❌ [effect] ${u}.fail`,
        params: t.value.params,
        error: t.value.error
      } : {
        type: `[effect] ${u}.${t.value.status}`
      };
    }
    if (D(t))
      return e.saveStoreUpdate(t), {
        type: `🧳 [store] ${f(t)}`,
        value: t.value
      };
    if (j(t))
      return e.saveStoreUpdate(t), {
        type: `🥗 [combine] ${f(t)}`,
        value: t.value
      };
    if (N(t) || O(t))
      return {
        type: `⭐️ [event] ${f(t)}`,
        params: t.value
      };
    if (F(t))
      return {
        type: `⏰ [${t.kind}] ${f(t)}`,
        value: t.value
      };
    if (M(t))
      return {
        type: "[forward]",
        value: t.value
      };
  };
}
function k(e) {
  return e.kind === "effect";
}
function h(e) {
  return e.kind === "event" && e.meta.named === "finally";
}
function _(e) {
  var t, n;
  return e.kind === "store" && !e.meta.derived && ((n = (t = e.meta) == null ? void 0 : t.named) == null ? void 0 : n.endsWith("inFlight"));
}
function D(e) {
  return e.kind === "store" && !e.meta.derived && !y(e);
}
function j(e) {
  return e.kind === "store" && e.meta.isCombine && !y(e);
}
function N(e) {
  return e.kind === "event" && !e.meta.derived && !y(e);
}
function O(e) {
  var t, n;
  return e.kind === "event" && ((n = (t = e.meta) == null ? void 0 : t.named) == null ? void 0 : n.startsWith("cases."));
}
function F(e) {
  return e.kind === "sample" || e.kind === "guard";
}
function M(e) {
  return e.kind === "forward";
}
const p = /* @__PURE__ */ new Map();
function T(e) {
  return p.has(e) || p.set(e, []), p.get(e);
}
function R(e) {
  const t = f(e), n = b(e);
  T(n).push(t);
}
function z(e) {
  const t = b(e), n = T(t), u = n.pop();
  return n.length === 0 && p.delete(t), u;
}
function y(e) {
  return !!e.meta.named;
}
function b(e) {
  return !k(e) || !h(e) ? null : e.stack.fxID;
}
function f(e) {
  return e.name || Q(e.loc) || `unknown_${e.id}`;
}
function Q(e) {
  return e ? `${e.file}:${e.line}:${e.column}` : null;
}
function B(e) {
  return e.map((t) => ({
    type: t.kind,
    name: t.name,
    value: t.value
  }));
}
function W(e) {
  if (!e)
    return {
      state: {},
      saveStoreUpdate: () => {
      }
    };
  const t = {}, n = {};
  function u(o) {
    let r = f(o);
    t[r] && t[r] !== o.id && (r = `${r} (${o.id})`), t[r] || (t[r] = o.id), n[r] = o.value;
  }
  return {
    state: n,
    saveStoreUpdate: u
  };
}
function X() {
  return (typeof globalThis < "u" ? globalThis : window).__REDUX_DEVTOOLS_EXTENSION__;
}
const g = {
  size: 100,
  latency: 500
};
function q(e, t, n) {
  if (!n)
    return (i) => e.send(i, {
      ...t
    });
  const {
    size: u,
    latency: o
  } = typeof n == "object" ? {
    ...g,
    ...n
  } : g, r = [], l = () => r, d = A(() => {
    const i = l();
    for (; i.length; ) {
      const a = i.shift();
      a && e.send(a.log, a.state);
    }
  }, o);
  return (i) => {
    r.push({
      log: i,
      state: Object.assign({}, t)
    }), r.length === u && r.shift(), d();
  };
}
function A(e, t) {
  let n;
  return () => {
    clearTimeout(n), n = setTimeout(() => {
      e();
    }, t);
  };
}
export {
  P as attachReduxDevTools
};
